import { Component, OnInit, Inject } from '@angular/core';
import { Book, BookResult } from 'src/app/models/api_models/book';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BookService } from 'src/app/api/book.service';


export class CancelConfirmData {
  constructor(
    public book : BookResult,
    public start : Date,
    public end : Date,
  ) {
    
  }
}

@Component({
  selector: 'app-book-cancel-confirm-dialog',
  templateUrl: './book-cancel-confirm-dialog.component.html',
  styleUrls: ['./book-cancel-confirm-dialog.component.scss']
})
export class BookCancelConfirmDialogComponent implements OnInit {

  private _start : Date = null;
  get start() : Date {return this._start;}
  set start(start : Date) {this._start = start;}
  
  private _end  : Date = null;
  get end() : Date {return this._end;}
  set end(end : Date) {this._end = end;}

  private _oldEnd  : Date = null;
  get oldEnd() : Date {return this._oldEnd;}
  set oldEnd(oldEnd : Date) {this._oldEnd = oldEnd;}
  
  private _book : BookResult  = null;
  get book(): BookResult {return this._book;}
  set book(book : BookResult) {this._book = book;}

  constructor( public dialogRef: MatDialogRef<BookCancelConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) public data : CancelConfirmData = null, private bookService : BookService, private router: Router) {
    this._end = data.end;
    this._start = data.start;
    this._book = data.book;
  }

  cancel() {
    this.dialogRef.close(null);
  }

  confirm() {
    // console.log("OK");
    if (this._book !== null ) {
      this.bookService.cancelBook(this._book.id).subscribe(
        response => {
          this.router.navigate(['/auth/tableau-de-bord' + this._book.id]);
          this.dialogRef.close(this._book.id);
        }
      )  
    }
  }

  ngOnInit() {
  }

}
